import { getSchema } from "@tiptap/core";
import { Color } from "@tiptap/extension-color";
import Highlight from "@tiptap/extension-highlight";
import Link from "@tiptap/extension-link";
import TaskItem from "@tiptap/extension-task-item";
import TaskList from "@tiptap/extension-task-list";
import TextAlign from "@tiptap/extension-text-align";
import { TextStyle } from "@tiptap/extension-text-style";
import Underline from "@tiptap/extension-underline";
import StarterKit from "@tiptap/starter-kit";
import { prosemirrorJSONToYXmlFragment, yXmlFragmentToProseMirrorRootNode } from "y-prosemirror";
import type * as Y from "yjs";

/** The note/document schema without collaboration plugins; shared by the editor, exports, and server-side moves. */
export const noteExtensions = () => [
  StarterKit.configure({ undoRedo: false, link: false, underline: false }),
  Underline,
  TextStyle,
  Color,
  Highlight.configure({ multicolor: true }),
  TextAlign.configure({ types: ["heading", "paragraph"] }),
  Link.configure({ openOnClick: false }),
  TaskList,
  TaskItem.configure({ nested: true }),
];

let cached: ReturnType<typeof getSchema> | null = null;
export const noteSchema = () => (cached ??= getSchema(noteExtensions()));

export const fragmentToJSON = (frag: Y.XmlFragment): unknown =>
  yXmlFragmentToProseMirrorRootNode(frag, noteSchema()).toJSON();
export const fragmentText = (frag: Y.XmlFragment): string =>
  yXmlFragmentToProseMirrorRootNode(frag, noteSchema()).textContent;
export const jsonToFragment = (json: unknown, frag: Y.XmlFragment) =>
  prosemirrorJSONToYXmlFragment(noteSchema(), json, frag);
